
import { defineComponent } from "vue";
import Report from "./Report.vue";
import ContainerReportFilter from "./ContainerReportFilter.vue";

export default defineComponent({
  components: {
    Report,
    ContainerReportFilter,
  },
  methods: {
    onReport(planId: any, options: any) {
      this.$refs.reportComponent.onReport(planId, options);
    },
    onStop() {
      this.$refs.reportComponent.onStop();
    },
  },
});
